import { TERMS_LINKS } from '@avalara/bat-apps-shared/constants';
import { translate } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import IframePaymentContainer from '../../containers/iframe-payment-container';
import { updateProductAnalytics } from '../../lib/side-effects/analytics';
import { addRiskAssessmentOffer } from '../../lib/side-effects/offers';
import { selectState } from '../../selectors';
import { setNeedToFetchCybersourceData } from '../../store/system';
import ExternalLink from '../external-link';
import PaymentSelection from '../shared/payment/payment-selection';
import PaymentText from '../shared/payment/payment-text';
import { RelativeDiv } from '../styled/skylab/page';

const RiskAssessmentPaymentView = () => {
  const {
    account: { accountId, isAdmin, isLoggedIn, paymentMethods, selectedPaymentMethod },
    buyFlow: { hideIframe },
    order: { discountAdditionalLegalText },
  } = useSelector(selectState);

  const history = useHistory();
  const dispatch = useDispatch();

  const shouldHideIframe = selectedPaymentMethod !== null || (isLoggedIn && isAdmin === false);

  const onSubmit = () => {
    dispatch(updateProductAnalytics('buy_now'));
    return accountId != null && selectedPaymentMethod != null
      ? dispatch(
          addRiskAssessmentOffer({
            history,
            paymentToken: selectedPaymentMethod.Id,
            successPage: '/risk-assessment/thank-you',
          }),
        )
      : undefined;
  };

  const disabled = isLoggedIn && isAdmin === false;

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    if (!shouldHideIframe) {
      dispatch(setNeedToFetchCybersourceData(true));
    } else {
      dispatch(setNeedToFetchCybersourceData(false));
    }
  }, [shouldHideIframe, hideIframe]);

  const showBuyButton = selectedPaymentMethod;
  const buttonText = !showBuyButton ? 'Finish' : 'Buy Now';

  return (
    <RelativeDiv>
      {isAdmin && !!paymentMethods.length && <PaymentSelection />}

      <IframePaymentContainer hideIframe={shouldHideIframe} />

      <PaymentText />
      <SRow>
        <SCol span='9' className='flex flex-dir-col margin-bottom-lg pad-bottom-lg'>
          <span className='get-started-button-container'>
            {showBuyButton && (
              <button
                type='button'
                data-ref='buy.risk-assessment.payment.submit-button'
                id='submit-payment'
                disabled={disabled}
                onClick={onSubmit}
                className='button primary large buy-now'
              >
                {buttonText}
              </button>
            )}
          </span>
          <span className='get-started-text-link'>
            {translate('client.disclaimer.by-clicking-accept-terms-and-ps', {
              buttonText,
              termsLink: (chunks) => (
                <ExternalLink href={TERMS_LINKS.esow} alwaysOpenInNewTab>
                  {chunks}
                </ExternalLink>
              ),
              professionalServicesLink: (chunks) => (
                <ExternalLink href={TERMS_LINKS.ps} alwaysOpenInNewTab>
                  {chunks}
                </ExternalLink>
              ),
            })}
          </span>
          {discountAdditionalLegalText != null && <p className='margin-top-sm'>{discountAdditionalLegalText}</p>}
        </SCol>
      </SRow>
    </RelativeDiv>
  );
};

export default RiskAssessmentPaymentView;
